import { render, staticRenderFns } from "./Stater.vue?vue&type=template&id=7c504d0a&scoped=true&"
import script from "./Stater.vue?vue&type=script&lang=js&"
export * from "./Stater.vue?vue&type=script&lang=js&"
import style0 from "./Stater.vue?vue&type=style&index=0&id=7c504d0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c504d0a",
  null
  
)

export default component.exports